import { Box } from "@material-ui/core";
import Body from "components/design-system/atoms/Typography/Body";
import LocalOfferPicto from "components/localOffer/assets/localOfferPicto.svg";
import ContainedSwitch from "../../atoms/ContainedSwitch";

export default function LocalOfferToggle({ isActivated, handleChange }) {
  return (
    <Box display="flex" alignItems="center" pr={2}>
      <Box display="flex" alignItems="center" mr={1}>
        <Box mr={1}>
          <LocalOfferPicto />
        </Box>
        <Body color="secondary.main" fontWeight="fontWeightMedium">
          Produits&nbsp;régionaux
        </Body>
      </Box>
      <ContainedSwitch checked={isActivated} onChange={handleChange} color="secondary" />
    </Box>
  );
}
